
import { gql } from "@apollo/client";

export const PAYROLL_STAMP = gql`
mutation PAYROLL_STAMP($idPayroll:ID!, $idCols: [ID!]) {
  PAYROLL_STAMP(idPayroll: $idPayroll, idCols: $idCols) {
    message
    token
  }
}`;

export const PAYROLL_EVENTUAL_STAMP = gql`
mutation PAYROLL_EVENTUAL_STAMP($idPayrollEventual:ID!,$stampAgain: Boolean, $idCols: [ID!], $userAdd: String) {
  PAYROLL_EVENTUAL_STAMP(idPayrollEventual: $idPayrollEventual, stampAgain:$stampAgain, idCols: $idCols, userAdd:$userAdd) {
    message
    token
  }
}`;

export const FORWARD_PAYROLL = gql`
mutation FORWARD_PAYROLL( $idCols: [ID!]) {
  FORWARD_PAYROLL( idCols: $idCols) 
}`;

export const GET_STATUS_PAYROLL_STAMP = gql`
query GET_STATUS_PAYROLL_STAMP($idPayroll: ID!, $idTracking: ID!){
  GET_STATUS_PAYROLL_STAMP(idPayroll: $idPayroll, idTracking: $idTracking) {
    collaboratorsResponse {
      Colaborador
      UUID
      CodigoError
      MensajeIncidencia
    }
    status
  }  
 }
`;

export const GET_STATUS_PAYROLL_STAMP_EVENTUAL = gql`
query GET_STATUS_PAYROLL_STAMP_EVENTUAL($idPayrollEventual: ID!, $idTracking: ID!){
  GET_STATUS_PAYROLL_STAMP_EVENTUAL(idPayrollEventual: $idPayrollEventual, idTracking: $idTracking) {
    collaboratorsEventualResponse {
      Colaborador
      UUID
      CodigoError
      MensajeIncidencia
    }
    status
  }  
 }
`;

export const CANCEL_EVENTUAL_STAMP = gql`
 mutation CANCEL_EVENTUAL_STAMP($input: cancelEventualStamp_Input) {
  CANCEL_EVENTUAL_STAMP(input: $input) {
    message
    token
  }
}` 

export const GET_STATUS_STAMP_EVENTUAL_CANCEL = gql`
query GET_STATUS_STAMP_EVENTUAL_CANCEL($idPayrollEventual: ID!, $idTracking: ID!){
  GET_STATUS_STAMP_EVENTUAL_CANCEL(idPayrollEventual: $idPayrollEventual, idTracking: $idTracking) {
    collaboratorsEventualResponse {
      Colaborador
      UUID
      CodigoError
      MensajeIncidencia
    }
    status
  }  
 }
`;

